import { Box, Text, useClipboard } from '@chakra-ui/react';
import Colors from '../../../../../../config/colors';
import { CopyIcon } from '@chakra-ui/icons';

interface Props {
    label: string;
    value: string | number;
    isCopyValue?: boolean;
}

export default function TransactionInfoItem({ label, value, isCopyValue = false }: Props) {
    const {
        onCopy,
        value: valueCopy,
        setValue: setValueCopy,
        hasCopied,
    } = useClipboard(value.toString());

    return (
        <Box display="flex" justifyContent="space-between">
            <Text>{label}</Text>
            <Box display="flex" alignItems="center" gap="2" onClick={onCopy} cursor="pointer">
                <Text color={Colors.lightGrey2}>{value}</Text>

                {isCopyValue && <CopyIcon color={hasCopied ? Colors.blue : 'inherit'} />}
            </Box>
        </Box>
    );
}
